import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import StructuredData from '@/components/base/StructuredData';
import { brandStats } from '@/mocks/homeData';

const testimonials = [
  {
    id: 1,
    name: '资深吃瓜群众',
    source: '微博用户 · 50万粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Anonymous%20user%20profile%20silhouette%20on%20dark%20background%2C%20minimalist%20avatar%20style%2C%20warm%20tones&width=100&height=100&seq=testimonial-01&orientation=squarish',
    rating: 4.9,
    comment: '吃瓜黑料网是我每天必刷的平台，爆料速度真的快！很多瓜在其他平台还没出来的时候，这里就已经有了详细报道。信息核实也很到位，从不乱传谣言。',
  },
  {
    id: 2,
    name: '娱乐圈观察者',
    source: '知乎大V · 30万关注',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20observer%20silhouette%20on%20dark%20background%2C%20minimalist%20style%2C%20warm%20tones&width=100&height=100&seq=testimonial-02&orientation=squarish',
    rating: 4.7,
    comment: '作为在娱乐圈摸爬滚打多年的老编辑，我可以负责任地说，吃瓜黑料网是目前国内娱乐爆料领域做得最专业的平台。每一条料都有据可查。',
  },
  {
    id: 3,
    name: '匿名爆料人',
    source: '平台注册用户 · 已贡献128条爆料',
    avatar: 'https://readdy.ai/api/search-image?query=Mysterious%20source%20silhouette%20on%20dark%20background%2C%20minimalist%2C%20warm%20tones&width=100&height=100&seq=testimonial-03&orientation=squarish',
    rating: 5.0,
    comment: '选择在吃瓜黑料网爆料是因为这里的审核团队专业且高效。我的每一条爆料都得到了及时处理，而且平台对爆料人的隐私保护做得非常到位，让人很放心。',
  },
];

const serviceFeatures = [
  {
    title: '实时追踪',
    description: '7×24小时全天候监测网络热点，确保每一条爆料都在第一时间送达你的眼前。',
    icon: 'ri-radar-line',
    image: 'https://readdy.ai/api/search-image?query=Radar%20screen%20with%20glowing%20dots%20on%20dark%20background%2C%20real-time%20monitoring%20theme%2C%20warm%20amber%20accents%2C%20cinematic&width=600&height=400&seq=service-feat-01&orientation=landscape',
  },
  {
    title: '严格核实',
    description: '每一条爆料都经过专业编辑团队的多方核实，确保信息的真实性和可靠性。',
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20documents%20on%20dark%20desk%2C%20investigation%20theme%2C%20warm%20lighting%2C%20cinematic&width=600&height=400&seq=service-feat-02&orientation=landscape',
  },
  {
    title: '隐私保护',
    description: '采用银行级数据加密，严格保护爆料人身份信息，让你爆料无忧。',
    icon: 'ri-lock-line',
    image: 'https://readdy.ai/api/search-image?query=Digital%20lock%20and%20shield%20on%20dark%20background%2C%20cybersecurity%20theme%2C%20warm%20golden%20glow%2C%20cinematic&width=600&height=400&seq=service-feat-03&orientation=landscape',
  },
];

export default function AboutPage() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const t = testimonials[currentTestimonial];

  return (
    <>
      <StructuredData type="about" />
      <Navbar />
      <main>
        <section className="relative bg-gradient-to-b from-primary-800 to-primary-900 pt-24 pb-20 md:pt-32 md:pb-28">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="inline-block px-4 py-1.5 rounded-full bg-secondary-500/30 text-secondary-200 text-xs mb-6">
                <span className="whitespace-nowrap">✦ 关于我们</span>
              </div>

              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-6">
                吃瓜黑料网
                <br />
                让每一个大瓜
                <br />
                都有迹可循
              </h1>

              <div className="max-w-2xl space-y-4 mb-12">
                <p className="text-base md:text-lg text-background-50/80 leading-relaxed">
                  吃瓜黑料网成立于2023年，是国内领先的娱乐爆料资讯聚合平台。我们致力于为广大网民提供最新、最全、最真实的网红黑料与明星塌房资讯，打造中国最专业的"吃瓜"社区。
                </p>
                <p className="text-sm md:text-base text-background-50/60 leading-relaxed">
                  平台拥有一支由资深娱乐记者、网络分析师和内容审核员组成的专业团队，每天24小时不间断追踪网络热点，确保用户能在第一时间获取最新鲜的爆料内容。我们坚持"有料必核、有瓜必追"的原则，对每一条爆料信息进行多方验证。
                </p>
                <p className="text-sm md:text-base text-background-50/50 leading-relaxed">
                  截至目前，平台已累计发布超过12万条经过严格核实的爆料资讯，日均活跃用户突破38万人次，月度页面浏览量超过2.8亿次，注册爆料人超过9.6万人。吃瓜黑料网已成为中国网民获取娱乐资讯的首选平台。
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
                <div>
                  <div className="rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Elegant%20modern%20newsroom%20with%20multiple%20screens%20displaying%20breaking%20news%2C%20warm%20dark%20and%20golden%20tones%2C%20professional%20atmosphere%2C%20cinematic%20lighting%2C%20sophisticated&width=600&height=400&seq=about-brand-img&orientation=landscape"
                      alt="吃瓜黑料网品牌展示"
                      title="吃瓜黑料网品牌"
                      className="w-full h-auto object-cover object-top"
                    />
                  </div>
                </div>

                <div className="flex flex-col justify-center">
                  <div className="text-6xl md:text-8xl font-heading font-black text-background-50 mb-4">
                    {brandStats.totalArticles}
                  </div>
                  <p className="text-sm md:text-base text-background-50/70 leading-relaxed mb-2">
                    累计发布爆料资讯，每一条都经过严格核实
                  </p>
                  <p className="text-sm text-background-50/50 leading-relaxed">
                    覆盖网红、明星、选秀、综艺等全娱乐领域，构建最完整的黑料数据库
                  </p>

                  <Link
                    to="/category/wanghong"
                    className="inline-flex items-center mt-8 px-6 py-3 rounded-full bg-background-50 text-primary-800 text-sm font-medium hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
                  >
                    浏览最新爆料
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
                  用户口碑
                </h2>
                <p className="mt-2 text-sm text-foreground-500">听听吃瓜群众怎么说</p>
              </div>

              <div className="bg-background-50 rounded-2xl p-6 md:p-10">
                <div className="flex items-start gap-4 mb-6">
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-sm font-medium whitespace-nowrap">
                    <i className="ri-star-fill text-accent-500"></i>
                    {t.rating}
                  </span>
                </div>

                <blockquote className="text-lg md:text-xl text-foreground-700 italic leading-relaxed mb-6">
                  "{t.comment}"
                </blockquote>

                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden bg-background-200">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.source}</p>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-end gap-2 mt-4">
                <button
                  type="button"
                  onClick={prevTestimonial}
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-200 bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line text-foreground-700"></i>
                </button>
                <button
                  type="button"
                  onClick={nextTestimonial}
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-10 md:mb-14 gap-4">
                <div>
                  <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider mb-1">
                    核心优势
                  </p>
                  <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 italic">
                    为什么选择我们
                  </h2>
                </div>
                <div className="max-w-md">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    三大核心优势，确保每一条爆料都经得起推敲，让每一位用户都能放心吃瓜。
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                {serviceFeatures.map((feature, index) => (
                  <div
                    key={feature.title}
                    className={`rounded-2xl overflow-hidden ${
                      index === 1 ? 'bg-primary-800' : 'bg-background-100'
                    }`}
                  >
                    {index === 1 ? (
                      <div className="p-8 flex flex-col items-center justify-center text-center min-h-[320px]">
                        <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500/20 mb-5">
                          <i className={`${feature.icon} text-3xl md:text-4xl text-accent-400`}></i>
                        </div>
                        <h3 className="text-xl font-heading font-bold text-background-50 mb-3">
                          {feature.title}
                        </h3>
                        <p className="text-sm text-background-50/70 leading-relaxed">
                          {feature.description}
                        </p>
                      </div>
                    ) : (
                      <>
                        <div className="aspect-[3/2] overflow-hidden">
                          <img
                            src={feature.image}
                            alt={feature.title}
                            title={feature.title}
                            className="w-full h-full object-cover object-top"
                            loading="lazy"
                          />
                        </div>
                        <div className="p-6">
                          <span className="inline-block px-3 py-1 text-xs rounded-full bg-accent-100 text-accent-800 mb-3">
                            {feature.title}
                          </span>
                          <p className="text-sm text-foreground-600 leading-relaxed">
                            {feature.description}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-primary-900">
          <div className="px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="font-heading text-3xl md:text-5xl font-black text-background-50 leading-tight mb-6">
                联系我们
              </h2>
              <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto leading-relaxed mb-4">
                如果你有爆料线索，或者对平台有任何建议，欢迎通过以下方式联系我们。
              </p>
              <p className="text-sm text-background-50/50 max-w-2xl mx-auto leading-relaxed mb-8">
                所有爆料信息严格保密，我们会在24小时内回复你的每一条消息。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
                <div className="p-5 rounded-xl bg-primary-800/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                    <i className="ri-mail-line text-accent-400 text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-background-50 mb-1">爆料邮箱</p>
                  <p className="text-xs text-background-50/50">tips@chiguaheiliao.com</p>
                </div>
                <div className="p-5 rounded-xl bg-primary-800/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                    <i className="ri-wechat-line text-accent-400 text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-background-50 mb-1">微信公众号</p>
                  <p className="text-xs text-background-50/50">吃瓜黑料网官方</p>
                </div>
                <div className="p-5 rounded-xl bg-primary-800/50">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500/20 mx-auto mb-3">
                    <i className="ri-phone-line text-accent-400 text-lg"></i>
                  </div>
                  <p className="text-sm font-medium text-background-50 mb-1">商务合作</p>
                  <p className="text-xs text-background-50/50">bd@chiguaheiliao.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}